module.exports = __webpack_public_path__ + "img/img_1.411c43b9.png";